import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import useService from '../../../useService';
import { Record } from '../../../helper';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdatePlatformFeature } = useService();

	const updatePlatformInfo = async (updatedData: Record) => {
		setShowLoader(true);
		try {
			const updatePlatformData: Record = { ...updatedData };
			const response: boolean = await requestUpdatePlatformFeature(updatePlatformData, showAlert);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: Record) => {
		updatePlatformInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
